import {AcceptedTimelineEvent} from '@ots-frontend/ots-data';
import {Text, ThemeIcon} from '@mantine/core'
import {useTranslation} from "react-i18next";
import {FormattedDateTime} from '../../date/FormattedDateTime/FormattedDateTime';
import {IconThumbUpFilled} from "@tabler/icons-react";

type Props = {
    event: AcceptedTimelineEvent;
};

export const AcceptedTimelineItemTitle = (props: {}) => {
    const {t} = useTranslation(["common"])
    return <>{t("common.entity.dispatchrequest.timeline.accepted.title", "Accepted")}</>
}

export const AcceptedTimelineItemBullet = (props: {}) => {
    return (
        <ThemeIcon
            size={22}
            color="dispatch-request-accepted"
            radius="xl"
        >
            <IconThumbUpFilled size={12}/>
        </ThemeIcon>
    )
}

export const AcceptedTimelineItem = (props: Props) => {
    const {event} = props;

    const {t} = useTranslation(["common"])

    return (
        <>
            <Text color="dimmed" size="sm">
                {t("common.entity.dispatchrequest.timeline.accepted.summary", "{{personName}} accepted the dispatch request.", {
                    personName: event.person ?? event.company ?? t("common.shared.user", "User")
                })}
            </Text>

            <Text size="xs" mt={4}>
                <FormattedDateTime date={event.date}/>
            </Text>
        </>
    );
};

AcceptedTimelineItem.Title = AcceptedTimelineItemTitle
AcceptedTimelineItem.Bullet = AcceptedTimelineItemBullet;
